import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('div', 'modalTitleBar', 'modal')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    margin: '0 0 10px 0',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalTitleBar.tsx